import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (backend/modules/pwp255/models/models.go)
// ============================================================

export interface FP621 {
  fp621_01: string;        // Packing No (FK to FP620)
  fp621_02: number;        // Seq No
  fp621_11: string;        // ROLL NO.
  fp621_12: string;        // COLOR/顏色代號
  fp621_121: string;       // 顏色備用
  fp621_13: string;        // 缸號
  fp621_14: number;        // YDS/PCS
  fp621_15: number;        // N.W.
  fp621_16: number;        // G.W.
  fp621_17: number;        // MTS
  fp621_18: number;        // 補布
  fp621_442: number;       // 備用數值
  fp621_91: string;        // 建立人員
  fp621_92: string | null; // 修改日期
  fp621_93: string;        // 修改時間
}

export interface FP620 {
  fp620_01: string;        // Packing No (7 chars, auto-generated)
  fp620_10: string;        // S/C NO.
  fp620_11: string | null; // Date
  fp620_12: string;        // (not on form UI)
  fp620_13: string;        // SHIPPING MARK
  fp620_14: string;        // DESCRIPTION OF GOODS (old, overwritten by fp620_141 at print)
  fp620_141: string;       // DESCRIPTION OF GOODS (main editable field)
  fp620_15: string;        // CONTAINER NO.
  fp620_16: string;        // 材積
  fp620_17: string;        // 客戶代號
  fp620_18: number;        // Total items count
  fp620_22: number;        // MTS conversion rate
  fp620_23: number;        // N.W. conversion rate
  fp620_24: number;        // G.W. factor
  fp620_25: number;        // Shipping unit (1=YDS 2=MTS 3=PCS)
  fp620_28: number;        // Knit/Flat (1=Knit 2=Flat)
  fp620_29: string;        // Product code
  fp620_91: string;        // 建立人員
  fp620_92: string | null; // 修改日期
  fp620_93: string;        // 修改時間
  details?: FP621[];
}

export interface ListResponse {
  data: FP620[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwp255';

export const pwp255Api = {
  list: async (page = 1, size = 20, keyword?: string): Promise<ListResponse> => {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  get: async (id: string): Promise<FP620> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (master: Partial<FP620>, details: Partial<FP621>[]): Promise<FP620> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FP620>, details: Partial<FP621>[]): Promise<FP620> => {
    const res = await apiClient.put(`${BASE}/${id}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};

export default pwp255Api;
